import { Box, Button, LazyToggleMethod } from '@factorialco/deprecated-design-system'
import { CardDetailFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { canApproveCard } from 'modules/banking/lib/cards/canApproveCard'

interface Props {
  card: CardDetailFragment
  toggleRejectModal: LazyToggleMethod
  toggleApproveModal: LazyToggleMethod
}

export const ApprovalActions = ({ card, toggleRejectModal, toggleApproveModal }: Props) => {
  const can = canApproveCard(card)

  if (!can) {
    return null
  }

  return (
    <Box flexDirection="row" gap="s4">
      <Button type="negative" onClick={() => toggleRejectModal(true)()}>
        {i18n.t('common.reject')}
      </Button>
      <Button type="positive" onClick={() => toggleApproveModal(true)()}>
        {i18n.t('common.approve')}
      </Button>
    </Box>
  )
}
